module.exports = __webpack_public_path__ + "ac8184aaee69387edb21e7bfa5ec4b8d.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-semibold.ttf
// module id = 92
// module chunks = 0